import { CustomerDBStatus, CustomersBySerial } from '@ip6m/types';
import { Injectable, Logger, OnApplicationBootstrap } from '@nestjs/common';
import { Observable } from 'rxjs';
import { createQueryBuilder, getRepository, Repository } from 'typeorm';
import { AddressEntity } from '../../models/address.entity';
import { CityEntity } from '../../models/city.entity';
import { CustomerEntity } from '../../models/customer.entity';
import { ServiceEntity } from '../../models/service.entity';
import { StreetEntity } from '../../models/street.entity';
import { DatabaseService } from '../database/database.service';
import { LocationService } from '../location/location.service';


@Injectable()
export class CustomerService {
  dbStatus: CustomerDBStatus;

 
  constructor(private databaseService:DatabaseService,private locationService:LocationService) {}
  


  async getCustomers() {
    let queryBuilder = this.databaseService.customerRepo
    .createQueryBuilder('customer')
    .leftJoinAndSelect('customer.billingAddress', 'location')
    .leftJoinAndSelect('location.street', 'street')
    .leftJoinAndSelect('street.city', 'city')
   
   
    
  let data=await queryBuilder.getMany()

  let resp=[]
  for (let i = 0; i < data.length; i++) {
     
      resp.push({
        customerId:data[i].customerId,
        name:data[i].name,
        company:data[i].company,
        city:data[i].billingAddress.street.city.name,
        street:data[i].billingAddress.street.name,
        zipcode:data[i].billingAddress.zipcode,
        houseNum:data[i].billingAddress.houseNum,
        apartment:data[i].billingAddress.apartment,
     
      })
  }
  
  return resp;
 


  }


  async createCustomer(params)
  {
   
   return this.locationService.newAddress(params).then(async(newAddress)=>{
      
     
      
      let newCust = new CustomerEntity()
      newCust.billingAddress=newAddress
      newCust.name=params.name
      newCust.company=params.company
   
      let result =await this.databaseService.customerRepo.save(newCust)
      let response={
        name:result.name,
        customerId:result.customerId,
        company:result.company,
        zipcode: result.billingAddress.zipcode,
        street: result.billingAddress.street.name,
        houseNum: result.billingAddress.houseNum,
        apartment: result.billingAddress.apartment,
        city:result.billingAddress.street.city.name
       
        
      }
     
      
      return response

   })
  }

  async updateCustomer(body,params)
  { 
    
    let f = await this.databaseService.customerRepo.createQueryBuilder('customer')
      .leftJoinAndSelect('customer.billingAddress','address')
      .where({customerId:params.id}).getOne()
    
      console.log(body)
      f.name=body.name
      f.company=body.company
     
      await this.locationService.newAddress(body).then(async(newAddress)=>{
      
      f.billingAddress=newAddress
      return
      })
    
      
      this.databaseService.locationRepo.save(f.billingAddress)
      
      await this.databaseService.customerRepo.save(f)
      
      
      
    
      let response={
        name:f.name,
        customerId:f.customerId,
        company:f.company,
        zipcode: f.billingAddress.zipcode,
        street: f.billingAddress.street.name,
        houseNum: f.billingAddress.houseNum,
        apartment: f.billingAddress.apartment,
        city:f.billingAddress.street.city.name
      }
      console.log("now")
      console.log(response)
        
     
    return response

 

    
  
  }

  /*
  


  async deleteCustomer(id:number) {
    
    let addressQuery=this.databaseService.customerRepo
    .createQueryBuilder('customer')
    .leftJoinAndSelect('customer.billingAddress','address')
    .where({customerId:id})
    
    let data=await addressQuery.getOne()
    let addressId=data.billingAddress.addressId
   
   

    let queryBuilder = this.databaseService.customerRepo
    .createQueryBuilder('customer')
    .delete()
    .from(CustomerEntity)
    .where({customerId:id})
    
    
    let error=false
    let result = await queryBuilder.execute().catch(()=>{
      error=true
    }).then((res:any)=>{
      if(error)return 2   //street is referenced by other address
      else if(res.affected==1)
      {
        //Delete address too if its not referenced anymore
        this.locationService.deleteAddress(addressId)
        
        return 0 //successful delete

         
      }
      else return 1  //no such street
    })

    return result

   
    

   
   

   
    


   
  }*/


  
}
